export default __webpack_public_path__ + "static/media/Bg-2.62c1906a.png";